/**
 * [NWF] Download Box
 *
 * Detects the size of the linked download file via a HEAD request
 * (reading the `Content-Length` response header) and appends it to the
 * button label, e.g. "Jetzt herunterladen (PDF 1.5 MB)".
 *
 * Runs only for buttons that carry a `data-nwf-download-url` attribute and
 * whose size has not been set manually in the section settings.
 */
(function () {
    function formatBytes(bytes) {
        if (bytes >= 1048576) {
            return (bytes / 1048576).toFixed(1) + ' MB';
        }
        return Math.round(bytes / 1024) + ' KB';
    }

    async function resolveSize(button) {
        const url = button.getAttribute('data-nwf-download-url');
        const target = button.querySelector('.nwf-download-box__size');
        if (!url || !target || target.textContent.trim() !== '') {
            return;
        }

        try {
            const response = await fetch(url, { method: 'HEAD' });
            const length = response.headers.get('content-length');
            if (response.ok && length) {
                target.textContent = ' ' + formatBytes(parseInt(length, 10));
            }
        } catch (error) {
            /* Network/CORS failure: leave the button without a size. */
        }
    }

    function init(root) {
        (root || document).querySelectorAll('[data-nwf-download-url]').forEach(resolveSize);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            init(document);
        });
    } else {
        init(document);
    }

    // Re-run when the section is re-rendered in the theme editor.
    document.addEventListener('shopify:section:load', function (event) {
        init(event.target);
    });
})();
